import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../../primitives/Backdrop/components/Container.js';
import { Fade } from '../../primitives/Transition/index.js';
export const Backdrop = /*#__PURE__*/_styled(forwardRef(({
  open,
  className,
  ...restProps
}, ref) => {
  return _jsx(Fade, {
    in: open,
    children: _jsx(Container, {
      ...restProps,
      ref: ref,
      className: className
    })
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e1jstn8s0"
} : {
  target: "e1jstn8s0",
  label: "Backdrop"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhY2tkcm9wLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9JIiwiZmlsZSI6IkJhY2tkcm9wLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3ggfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL0JhY2tkcm9wL2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmltcG9ydCB7IEZhZGUgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL1RyYW5zaXRpb24vaW5kZXguanMnO1xuZXhwb3J0IGNvbnN0IEJhY2tkcm9wID0gc3R5bGVkKGZvcndhcmRSZWYoKHsgb3BlbiwgY2xhc3NOYW1lLCAuLi5yZXN0UHJvcHMgfSwgcmVmKSA9PiB7XG4gICAgcmV0dXJuIChfanN4KEZhZGUsIHsgaW46IG9wZW4sIGNoaWxkcmVuOiBfanN4KENvbnRhaW5lciwgeyAuLi5yZXN0UHJvcHMsIHJlZjogcmVmLCBjbGFzc05hbWU6IGNsYXNzTmFtZSB9KSB9KSk7XG59KSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1CYWNrZHJvcC5qcy5tYXAiXX0= */");